<template>
  <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
    <multiselect v-model="selected" :custom-label="getLabel" track-by="_id" :placeholder="$t('selectBrandname')"
                 :options="items" :multiple="multiple"
                 @input="onInput" @search-change="search">
      <template v-slot:noResult>
        {{ $t('notFoundSearch') }}
      </template>
      <template v-slot:noOptions>
        {{ $t('notFoundSearch') }}
      </template>
    </multiselect>
  </b-form-group>
</template>

<script>
import _ from 'lodash';
import list from '@/mixins/List';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: {
    model: Object,
    attribute: {
      type: String,
      default: 'brandname'
    },
    clientAttribute: String,
    label: String,
    errors: Array,
    placeholder: {
      type: String,
      default: 'selectBrandname'
    },
    multiple: Boolean,
    isFilter: Boolean
  },
  components: {Multiselect},
  mixins: [list],
  data() {
    return {
      selected: null,
      state: null,
      errorTxt: '',
      options: [],
      showList: false,
      service: '/viber-brand-name',
      autoLoad: false,
      defaultFilterFormModel: {
        keyword: '',
        client: this.clientAttribute && this.model[this.clientAttribute] ? this.model[this.clientAttribute] : null,
      },
      focused: false,
      changeTrigger: true,
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        if (this.clientAttribute && val[this.clientAttribute]) {
          this.filterFormModel.client = this.model[this.clientAttribute] ? this.model[this.clientAttribute] : null;
          this.load();
        }

        if (val[this.attribute] != null) {
          if (this.changeTrigger) {
            this.loadSelected();
          }
          this.changeTrigger = true;
        } else {
          this.selected = null;
        }
      }, deep: true
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    onInput() {
      let val = this.selected;
      this.changeTrigger = false;
      if (val === null) {
        this.model[this.attribute] = val;
      } else if (this.multiple) {
        this.model[this.attribute] = val.map(s => s._id);
      } else {
        this.model[this.attribute] = val._id;
      }
      this.$emit('change');
    },
    getLabel({name}) {
      return `${name}`;
    },
    search: _.debounce(function (event) {
      this.filterFormModel.keyword = event;
      this.filterFormModel.page = 1;
      this.load();
    }, 250),
    loadSelected() {
      if (this.model[this.attribute]) {
        let idc;
        if (this.multiple) {
          idc = this.model[this.attribute].join(',');
        } else {
          idc = this.model[this.attribute];
        }
        if (idc) {
          this.$bgService.get(this.service+`/${idc}`).then(response => {
            if (this.multiple) {
              this.selected = response.data.docs;
            } else if (response.data) {
              this.selected = response.data;
            }
          });
        }
      }
    }
  },
  mounted() {
    this.selected = null;
    this.loadSelected();
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectBrandname: 'Select Brandname'
      },
      vi: {
        selectBrandname: 'Chọn Brandname'
      }
    }
  }
}
</script>